import type {ILabel} from '../../../../../types'

export default {
    startPrice: <ILabel>{
        de: 'Startpreis',
        en: 'Start Price',
        es: 'Precio inicial',
        fr: 'Prix de départ',
        nl: 'Startprijs',
        it: 'Start',
    },
    currentPrice: <ILabel>{
        de: 'Jetzt',
        en: 'Now',
        es: 'Ahora',
        fr: 'Prix de actuel',
        nl: 'Nu',
        it: 'Adesso',
    },
    quantity: <ILabel>{
        de: 'Noch',
        en: 'Items left',
        es: 'Quedan',
        fr: 'Bijoux disponibles',
        nl: 'Artikelen over',
        it: 'Disponibili',
    }
}